import { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { User, Settings, LogOut, ChevronDown } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const links = [
  { label: 'Overview',   to: '/' },
  { label: 'Vision',     to: '/vision' },
  { label: 'Fleet',      to: '/fleet' },
  { label: 'Technology', to: '/technology' },
  { label: 'Ecosystem',  to: '/ecosystem' },
  { label: 'About Us',   to: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const userRef = useRef(null);

  const meta = user?.user_metadata || {};
  const displayName = meta.name || user?.email?.split('@')[0] || 'Account';
  const initials = (meta.name || user?.email || '?')
    .split(' ').map(s => s[0]).slice(0, 2).join('').toUpperCase();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); setUserOpen(false); }, [location]);

  // Close the user dropdown on outside click
  useEffect(() => {
    const onClick = (e) => {
      if (userRef.current && !userRef.current.contains(e.target)) setUserOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="nav-logo">
        <img src="/axion-logo.png" alt="Axion Mobility" className="nav-logo-img" />
      </Link>

      <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {links.map(l => (
          <Link
            key={l.to}
            to={l.to}
            className={location.pathname === l.to ? 'active' : ''}
          >
            {l.label}
          </Link>
        ))}
        <Link to="/contact" className="nav-cta">Contact Sales</Link>

        {/* User menu */}
        <div className="nav-user" ref={userRef}>
          <button className="nav-user-btn" onClick={() => setUserOpen(o => !o)}>
            <span className="nav-user-avatar">{initials}</span>
            <span className="nav-user-name">{displayName}</span>
            <ChevronDown size={15} className={`nav-user-chev ${userOpen ? 'open' : ''}`} />
          </button>

          {userOpen && (
            <div className="nav-user-menu">
              <div className="nav-user-head">
                <p className="nuh-name">{meta.name || 'Axion User'}</p>
                <p className="nuh-email">{user?.email}</p>
              </div>
              <Link to="/account" className="nav-user-item">
                <User size={16} /> My Account
              </Link>
              <Link to="/account" className="nav-user-item">
                <Settings size={16} /> Settings
              </Link>
              <button className="nav-user-item nav-user-item--danger" onClick={handleSignOut}>
                <LogOut size={16} /> Sign Out
              </button>
            </div>
          )}
        </div>
      </div>

      <button
        className={`hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}
